import {React} from '@api'

export type BorderLocation = 'top' | 'left' | 'right' | 'bottom'

class PdfStylesStore {
  border = (locations: BorderLocation | BorderLocation[], style = 'solid', width = 1, color = 'black') => {
    locations = _.isArray(locations) ? locations : [locations]

    return locations.reduce<any>((p, l) => ({
      ...p,
      [`border${_.capitalize(l)}Style`]: style,
      [`border${_.capitalize(l)}Width`]: width,
      [`border${_.capitalize(l)}Color`]: color
    }), {})
  }
}

export const pdfStylesStore = new PdfStylesStore()


// WEBPACK FOOTER //
// ./src/modules/pdf/PdfStylesStore.tsx